// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/style.scss
// module id = 69
// module chunks = 0